/* Sns Error Module */
import { FeatureError } from '@/libs/errors/FeatureError';
import { T } from '@/libs/translation';

/** @description req.user에 값이 들어오지 않은 경우*/
export const SNS_001 = (error?: Error) =>
  new FeatureError(
    {
      title: T('sns.error.001_title'),
      message: T('sns.error.001_message'),
      code: 'SNS_001',
    },
    error,
  );

/** @description SNS 회원가입 페이지에 접속했으나 세션에 데이터가 없는 경우*/
export const SNS_002 = (error?: Error) =>
  new FeatureError(
    {
      title: T('sns.error.002_title'),
      message: T('sns.error.002_message'),
      code: 'SNS_002',
    },
    error,
  );

/** @description SNS 연결 시도 중 세션의 이메일과 요청한 이메일이 일치하지 않는 경우*/
export const SNS_003 = (error?: Error) =>
  new FeatureError(
    {
      title: T('sns.error.003_title'),
      message: T('sns.error.003_message'),
      code: 'SNS_003',
    },
    error,
  );

/** @description SNS 연결 시도 중 이미 연결된 sns_type을 연결하려는 경우*/
export const SNS_004 = (error?: Error) =>
  new FeatureError(
    {
      title: T('sns.error.004_title'),
      message: T('sns.error.004_message'),
      code: 'SNS_004',
    },
    error,
  );

/** @description SNS 연결 시도 중 존재하지 않는 email에 연결하려는 경우*/
export const SNS_005 = (error?: Error) =>
  new FeatureError(
    {
      title: T('sns.error.005_title'),
      message: T('sns.error.005_message'),
      code: 'SNS_005',
    },
    error,
  );

/** @description SNS 연결 시도 중 이미 다른 user에 연결된 sns 정보를 추가하는 경우*/
export const SNS_006 = (error?: Error) =>
  new FeatureError(
    {
      title: T('sns.error.006_title'),
      message: T('sns.error.006_message'),
      code: 'SNS_006',
    },
    error,
  );

/** @description SNS_TYPE이 유효하지 않는 경우*/
export const SNS_007 = (error?: Error, sns_type?: string) =>
  new FeatureError(
    {
      title: T('sns.error.007_title', { sns_type }),
      message: T('sns.error.007_message', { sns_type }),
      code: 'SNS_007',
    },
    error,
  );

/** @description 유저가 SNS_TYPE으로 가입되지 않은 경우*/
export const SNS_008 = (error?: Error, sns_type?: string) =>
  new FeatureError(
    {
      title: T('sns.error.008_title', { sns_type }),
      message: T('sns.error.008_message', { sns_type }),
      code: 'SNS_008',
    },
    error,
  );

/** @description 가입된 sns가 하나이며 유저가 sns로 바로 가입하여 password 입력이 필요한 경우*/
export const SNS_009 = (error?: Error) =>
  new FeatureError(
    {
      title: T('sns.error.009_title'),
      message: T('sns.error.009_message'),
      code: 'SNS_009',
    },
    error,
  );

/** @description A라는 이메일을 회원가입 -> B라는 이메일로 SNS-C 타입을 마이페이지에서 연결 -> A라는 이메일을 가진 SNS-C 타입으로 로그인 시도*/
export const SNS_010 = (error?: Error) =>
  new FeatureError(
    {
      title: T('sns.error.010_title'),
      message: T('sns.error.010_message'),
      code: 'SNS_010',
    },
    error,
  );
